export const escapeHtml = (text: string) => {
  return text.replace(
    /["&<>]/g,
    a => (({ '"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;' } as any)[a]),
  );
};

export const encodeCode = (language: string) => (unencodedCode: string) => {
  if (language === 'markup' || language === 'jsx') {
    return { __html: escapeHtml(unencodedCode) };
  } else {
    return { __html: unencodedCode };
  }
};
